module.exports = __webpack_public_path__ + "img/man_ray.1ba8a5f9.jpg";